function removeLogoFromUC() {
  const shadowRoot = document.getElementById('usercentrics-root').shadowRoot;
  const style = document.createElement('style');
  style.innerHTML = `
    img[alt="Logo eRecht24"] {
      display: none;
    }
  `;
  shadowRoot.prepend(style);
}

if (window.UC_UI && window.UC_UI.isInitialized()) {
  removeLogoFromUC();
} else {
  window.addEventListener('UC_UI_INITIALIZED', function () {
    removeLogoFromUC();
  });
}
